import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";

export default function Home() {
  const navigate = useNavigate();

  const categories = [
    { tag: "01", title: "Suits & Tuxedos", desc: "Sharp tailoring for every occasion", to: "/products" },
    { tag: "02", title: "Evening Gowns", desc: "Floor-length elegance, made to turn heads", to: "/products" },
    { tag: "03", title: "Shirts & Blouses", desc: "Crisp foundations in premium cotton", to: "/products" },
    { tag: "04", title: "Footwear", desc: "Hand-finished leather oxfords & heels", to: "/products" },
    { tag: "05", title: "Accessories", desc: "Ties, cufflinks & the finishing touch", to: "/products" },
    { tag: "06", title: "Coats & Blazers", desc: "Structured outerwear, season after season", to: "/products" },
  ];

  const features = [
    { icon: "✦", title: "Bespoke Tailoring", desc: "Made-to-measure fits crafted by master tailors for an impeccable silhouette." },
    { icon: "❖", title: "AI Style Concierge", desc: "Personalised styling guidance, 24/7, in Arabic & English." },
    { icon: "✧", title: "White-Glove Delivery", desc: "Garment-bag shipping with real-time tracking, nationwide." },
    { icon: "◆", title: "Effortless Returns", desc: "Complimentary alterations and 30-day exchanges on every order." },
  ];

  const stats = [
    { value: "12K+", label: "Garments Tailored" },
    { value: "9,800", label: "Dressed Clients" },
    { value: "40+", label: "Master Tailors" },
    { value: "24/7", label: "Style Concierge" },
  ];

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.heroOverlay} />
        <div className={`container ${styles.heroContent}`}>
          <span className={styles.eyebrow}>Egypt's House of Formal Wear</span>
          <h1 className={styles.heroTitle}>
            Dressed for the<br />
            <span className={styles.italic}>moments</span> that matter
          </h1>
          <p className={styles.heroSub}>
            Tailored suits, couture gowns, and refined formal essentials — crafted with
            precision and delivered with care, guided by your personal AI stylist.
          </p>
          <div className={styles.heroActions}>
            <button className="btn-primary" onClick={() => navigate("/products")}>
              Explore the Collection
            </button>
            <button className={styles.heroGhost} onClick={() => navigate("/chat")}>
              Book a Style Concierge →
            </button>
          </div>

          <div className={styles.heroMeta}>
            {stats.map((s) => (
              <div key={s.label} className={styles.heroStat}>
                <span className={styles.heroStatValue}>{s.value}</span>
                <span className={styles.heroStatLabel}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.catSection}>
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">The Wardrobe</span>
            <h2>Shop by Category</h2>
            <div className="divider-gold" />
          </div>
          <div className={styles.catGrid}>
            {categories.map((c) => (
              <button key={c.title} className={styles.catCard} onClick={() => navigate(c.to)}>
                <span className={styles.catTag}>{c.tag}</span>
                <div className={styles.catBody}>
                  <h3>{c.title}</h3>
                  <p>{c.desc}</p>
                </div>
                <span className={styles.catArrow}>→</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.featureSection}>
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">Why Atelier Noir</span>
            <h2>The House Standard</h2>
            <div className="divider-gold" />
          </div>
          <div className={styles.featuresGrid}>
            {features.map((f) => (
              <div key={f.title} className={styles.featureCard}>
                <div className={styles.featureIcon}>{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className={styles.ctaSection}>
        <div className="container">
          <div className={styles.ctaBox}>
            <div className={styles.ctaInner}>
              <span className={styles.ctaEyebrow}>Made to Measure</span>
              <h2>Ready to be perfectly dressed?</h2>
              <p>Browse the collection or let our AI concierge curate a look for your next occasion.</p>
              <div className={styles.ctaActions}>
                <button className="btn-primary" onClick={() => navigate("/products")}>
                  Start Shopping
                </button>
                <button
                  className="btn-secondary"
                  style={{ borderColor: "rgba(255,255,255,0.5)", color: "#fff" }}
                  onClick={() => navigate("/chat")}
                >
                  Talk to a Stylist
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
